<div class="container-fluid">
  <div class="modal-header">
    <h4>
      <!-- check icon img -->
      Sistemas Pesquisados
    </h4>
      <button type="button" class="close btn" (click)="fecharModal()">Fechar</button>
    </div>
  <div class="modal-body">
    <!-- header -->
    <div class="row fw-bold">
      <div class="col-md-3 pt-3 pb-3">Sistema</div>
      <div class="col-md-7 pt-3 pb-3">Status</div>
      <div class="col-md-1 pt-3 pb-3">Tempo</div>
      <div class="col-md-1 pt-3 pb-3">Hotéis</div>
    </div>
    <!-- data  -->
    <div class="row" *ngFor="let fornecedor of infoFornecedores">
      <div class="col-md-3 pt-3 pb-3 box-cell">{{fornecedor.Sistema}}</div>
      <div class="col-md-7 pt-3 pb-3 box-cell">{{fornecedor.Status}}</div>
      <div class="col-md-1 pt-3 pb-3 box-cell">{{fornecedor.Tempo}} s</div>
      <div class="col-md-1 pt-3 pb-3 box-cell">{{fornecedor.Hoteis}}</div>
    </div>
  </div>
</div>